import { SpaceModel } from "shared/models/TaskTracker";
import { observable } from "shared/utilities";

export const Store = observable({
    spaces: [] as SpaceModel[],
});
